"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SelectedMode;

var _react = _interopRequireDefault(require("react"));

var _SelectedModeModule = _interopRequireDefault(require("./SelectedMode.module.scss"));

var _character = _interopRequireDefault(require("../../../../../mocks/character"));

var _LobbySeatBadge = _interopRequireDefault(require("../SelectMode/components/LobbySeatBadge/LobbySeatBadge"));

var _Button = _interopRequireDefault(require("../../../../inputElements/Button/Button"));

var _EButtonType = _interopRequireDefault(require("../../../../inputElements/Button/EButtonType"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SelectedMode(_ref) {
  var onSubmit = _ref.onSubmit,
      onCancel = _ref.onCancel,
      onDelete = _ref.onDelete;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _SelectedModeModule.default.selected
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _SelectedModeModule.default.seat
  }, /*#__PURE__*/_react.default.createElement(_LobbySeatBadge.default, {
    character: _character.default
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _SelectedModeModule.default.controls
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _SelectedModeModule.default.backAndDelete
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.SELECT,
    onClick: onCancel
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _SelectedModeModule.default.buttonContent
  }, "Back")), /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.SELECT,
    onClick: onDelete
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _SelectedModeModule.default.buttonContent
  }, "Delete"))), /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.SELECT,
    onClick: onSubmit
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _SelectedModeModule.default.buttonContent
  }, "Start"))));
}